// 售价表单的草稿与换算，字段见 docs/03 3.8。价格只增不改，每次提交是一个新版本。
import { pricingInput, type PricingFieldsDraft } from "./pricingDraft";
import type { Errors } from "@/app/useDraft";
import type { ChargeOn, Input, SellPrice } from "@/app/master";

export interface PriceDraft extends PricingFieldsDraft { customer_id: string; account_id: string }

export function priceDraft(accountId = "", currency = "", customerId = "", chargeOn: ChargeOn = "submitted"): PriceDraft {
  return { customer_id: customerId, charge_on: chargeOn, account_id: accountId, mcc: "", mnc: "", price: "", currency, effective_from: "" };
}

export function priceInput(d: PriceDraft): { body?: Input<SellPrice>; errors: Errors<PriceDraft> } {
  const common = pricingInput(d);
  const errors: Errors<PriceDraft> = { ...common.errors };
  if (!d.customer_id) errors.customer_id = "选择客户。";
  if (!d.account_id) errors.account_id = "选择账号。";
  if (Object.keys(errors).length || !common.body) return { errors };
  return { errors, body: { ...common.body, account_id: Number(d.account_id), correction_of: null } };
}
